import { CHART_CATEGORIES } from 'constants/chart-categories';
import { get } from 'lodash';
import { CHOROPLETH_DEFAULTS } from 'constants/geospatial';
import { MAP_TOPOJSON_PRESETS } from 'constants/geospatial';

export default {
  name: 'Geospatial Choropleth',
  displayName: 'Choropleth',
  order: 0,
  flavour: 'discrete',
  category: CHART_CATEGORIES.GEOSPATIAL,
  iconValue: 'geo-choropleth',
  channels: [
    {
      name: 'location',
      displayName: 'Location',
      required: true,
      channelType: 'category',
      intent: 'category-axis',
    },
    {
      name: 'color',
      displayName: 'Color',
      required: true,
      channelType: 'aggregation',
      intent: 'value-axis',
    },
  ],
  specFn: (encodings, customisations) => {
    return {
      opacity:
        parseInt(
          get(
            customisations.options,
            'geospatialOpacity.value',
            CHOROPLETH_DEFAULTS.opacity
          ),
          10
        ) / 100,
      titles: {
        location: get(encodings, 'location.title'),
        color: get(encodings, 'color.title'),
      },
      customisations: {
        color: get(customisations, 'channels.color'),
      },
      topoJSON: get(
        customisations.options,
        'mapTopoJSON.value',
        MAP_TOPOJSON_PRESETS.WORLD_COUNTRIES
      ),
    };
  },
};
